import dayjs from "dayjs";

export const getDataAwareSourceName = dataAware =>
  String(dataAware ?? "")
    .replace(/[{}]/g, "")
    .trim();

export const getDataAwareSourceNames = dataAware =>
  String(dataAware ?? "")
    .split(",")
    .map(getDataAwareSourceName)
    .filter(Boolean);

export const parseDateByFormat = (dateValue, sourceFormat = "YYYY-MM-DD") => {
  if (!dateValue || !sourceFormat) return null;

  const valueParts = String(dateValue).trim().split(/[-/]/);
  const formatParts = String(sourceFormat).trim().toUpperCase().split(/[-/]/);

  if (valueParts.length !== formatParts.length) return null;

  const dateParts = formatParts.reduce((parts, token, index) => {
    parts[token] = Number(valueParts[index]);
    return parts;
  }, {});
  const { YYYY: year, MM: month, DD: day } = dateParts;

  if (![year, month, day].every(Number.isFinite)) return null;

  const parsedDate = dayjs(
    `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
  );

  if (
    !parsedDate.isValid() ||
    parsedDate.year() !== year ||
    parsedDate.month() + 1 !== month ||
    parsedDate.date() !== day
  ) {
    return null;
  }

  return parsedDate;
};

export const applyDateOperation = (baselineDate, operationType, operationValue) => {
  const numericAmount = Number(operationValue);
  const operation = String(operationType ?? "").trim().toUpperCase();
  const baseline = dayjs.isDayjs(baselineDate) ? baselineDate : dayjs(baselineDate);

  if (
    !baseline.isValid() ||
    operationValue === "" ||
    operationValue === null ||
    operationValue === undefined ||
    !Number.isFinite(numericAmount)
  ) {
    return null;
  }

  // Date operations use whole calendar days. Explicit truncation prevents
  // Day.js from rounding a decimal backend value up to an extra day.
  const amount = Math.trunc(numericAmount);

  if (operation === "ADD") {
    return baseline.add(amount, "day");
  }

  if (operation === "SUBTRACT") {
    return baseline.subtract(amount, "day");
  }

  return null;
};
